module.exports = __webpack_public_path__ + "img/bopixbo_bobocoin.gm.ee81518.png";